const ViewMember = ({ t }) => {
  return (
    <div className="space-y-4">
      <section className="space-y-1">
        <h3 className="text-lg font-semibold text-primary">{t("personalInfo")}</h3>
        <div className="p-3 space-y-4 border border-primary rounded-xl">
          <div className="flex flex-wrap items-center justify-between md:flex-nowrap">
            <div className="w-full">
              <p className="font-medium text-mainGray">{t("fullName")}</p>
              <p className="font-semibold">هشام المدير هشام</p>
            </div>
            <div className="w-full">
              <p className="font-medium text-mainGray">{t("idNumber")}</p>
              <p className="font-semibold">1234567890</p>
            </div>
          </div>
          <div className="flex flex-wrap items-center justify-between md:flex-nowrap">
            <div className="w-full">
              <p className="font-medium text-mainGray">{t("phone")}</p>
              <p className="font-semibold">0501234567</p>
            </div>
            <div className="w-full">
              <p className="font-medium text-mainGray">{t("nationality")}</p>
              <p className="font-semibold">اردني</p>
            </div>
          </div>
        </div>
      </section>
      <section className="space-y-1">
        <h3 className="text-lg font-semibold text-primary">{t("subsInfo")}</h3>
        <div className="p-3 space-y-4 border border-primary rounded-xl">
          <div className="flex items-center justify-between">
            <div className="w-full">
              <p className="font-medium text-mainGray">{t("membershipType")}</p>
              <p className="font-semibold">VIP</p>
            </div>
            <div className="w-full">
              <p className="font-medium text-mainGray">{t("joinDate")}</p>
              <p className="font-semibold">12/06/2023</p>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="w-full">
              <p className="font-medium text-mainGray">{t("expiryDate")}</p>
              <p className="font-semibold">12/06/2024</p>
            </div>
            <div className="w-full">
              <p className="font-medium text-mainGray">{t("status")}</p>
              <p className="font-semibold py-2 px-3 w-fit rounded text-white bg-[#11A849]">
                فعالة
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewMember;
